/**
 * 事件类型
 */
enum EventTypes {
  USER_LOGIN = 'USER_LOGIN', // 用户登录成功，self接口调用完成
  ADD_TAB = 'ADD_TAB', // 打开TAB
  ACTIVE_TAB_CHANGE = 'ACTIVE_TAB_CHANGE', // 标签页变更
  REMOVE_TAB = 'REMOVE_TAB', // 移除Tab
  USER_LOGOUT = 'USER_LOGOUT', // 用户退出登录
}

export default EventTypes;
